import React, { useState } from "react";

export default function Temperature(props) {
 
  const [unit, setUnit] = useState("celsius");
  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  function showCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  if (unit === "celsius") {
    return (
      <div className="temperatureWeather">
        <span>
          <strong>{props.celsius}º</strong>
        </span>
        <span>
          C |{" "}
          <a href="/" onClick={showFahrenheit}>
            F
          </a>
        </span>
      </div>
    );
  } else {
    let fahrenheit = (props.celsius * 9) / 5 + 32;

    return (
      <div className="temperatureWeather">
        <span>
          <strong>{Math.round(fahrenheit)}º</strong>
        </span>
        <span>
          <a href="/" onClick={showCelsius}>
            C
          </a>{" "}
          | F
        </span>
      </div>
    );
  }
}
